import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=7a50c681&scoped=true&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a50c681",
  null
  
)

export default component.exports